/**
 * Agent is in format alpha.agent-1  => [prefix].[agentId]
 * Return agentId only
 */
export function getUserFriendlyAgentLabel (label) {
  if (label.includes('.')) {
    return label.split('.')[1]
  }
  return label
}

/**
 * Container name
 * Return Container name
 */
export function getContainerNameLabel (label) {
  if (label.startsWith('/')) {
    return label.slice(1)
  }
  return label
}



// WEBPACK FOOTER //
// ./src/utilities/agent.helper.js